import { alpha, makeStyles } from '@material-ui/core';

export default makeStyles((theme) => {
  const {
    palette: {
      common: { scrollbar },
    },
  } = theme;
  return {
    classes: {
      'scrollbarColor': `${scrollbar} transparent`,
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        'backgroundColor': alpha(scrollbar, 0.8),
        '&:hover': {
          backgroundColor: scrollbar,
        },
      },
    },
  };
});
